__turbopack_context__.v({
  "badge": "EsRetailSaleModal-module__oZNOZa__badge",
  "buyNow": "EsRetailSaleModal-module__oZNOZa__buyNow",
  "close": "EsRetailSaleModal-module__oZNOZa__close",
  "description": "EsRetailSaleModal-module__oZNOZa__description",
  "dialog": "EsRetailSaleModal-module__oZNOZa__dialog",
  "finePrint": "EsRetailSaleModal-module__oZNOZa__finePrint",
  "header": "EsRetailSaleModal-module__oZNOZa__header",
  "overlay": "EsRetailSaleModal-module__oZNOZa__overlay",
  "retailerLink": "EsRetailSaleModal-module__oZNOZa__retailerLink",
  "retailerLogo": "EsRetailSaleModal-module__oZNOZa__retailerLogo",
  "retailerName": "EsRetailSaleModal-module__oZNOZa__retailerName",
  "retailers": "EsRetailSaleModal-module__oZNOZa__retailers",
  "title": "EsRetailSaleModal-module__oZNOZa__title",
});
